module.exports = __webpack_public_path__ + "static/media/puzzle-29-bg.5b19d2c0.svg";